import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  max-width: 1415px;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`

export const ItemWrapper = styled.div`
  display: flex;
  margin: 1.4rem 2rem;

  align-items: center;
  height: 71px;
  max-width: 280px;
  width: 100%;
  background-color: #edf3ff;
  > svg {
    margin: 6px;
  }
  > p {
    font-size: 21px;
    font-weight: 500;
    height: auto;
    margin-left: 15px;
  }
`
